import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"
import { CONTROLS as controllers } from "@/config/controls"

/**
 * cn
 * @param inputs
 * @returns
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * sortObjectByKeysOrder
 * @param obj
 * @param order
 * @returns
 */
export function sortObjectByKeysOrder(obj, order) {
  // Crée un nouvel objet pour le résultat
  const sortedObj = {}

  // Itère sur le tableau d'ordre
  order.forEach((key) => {
    if (obj[key]) {
      // Ajoute la clé à l'objet trié si elle existe dans l'objet original
      sortedObj[key] = obj[key]
    }
  })

  return sortedObj
}

/**
 * randomInRange
 * @param min
 * @param max
 * @returns
 */
export function randomInRange(min, max) {
  return Math.random() * (max - min) + min
}

/**
 * controllersEvents
 * @param callback
 */
export function controllersEvents(callback) {
  const controls = [...controllers, "b", "a"]
  let index = 0
  function addStack(event) {
    if (event.key === controls[index]) {
      index++
      if (index === controls.length) {
        callback()
        index = 0
      }
    } else {
      index = 0
    }
  }

  document.addEventListener("keydown", addStack)
}

/**
 * Convert hex color to HSL
 * @param hex hex color to convert
 * @param adjustments Optional object to adjust lightness or saturation
 * @returns HSL color as a string
 */
export function hexToHSL(
  hex: string,
  adjustments: { lightness?: number; saturation?: number } = {}
) {
  // Remove the hash if it's there
  hex = hex.replace(/^#/, "")

  // Parse the hex values
  const r = parseInt(hex.slice(0, 2), 16) / 255
  const g = parseInt(hex.slice(2, 4), 16) / 255
  const b = parseInt(hex.slice(4, 6), 16) / 255

  const max = Math.max(r, g, b)
  const min = Math.min(r, g, b)
  let h: number = 0
  let s: number = 0
  let l: number = (max + min) / 2

  if (max === min) {
    h = s = 0 // achromatic
  } else {
    const d = max - min
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0)
        break
      case g:
        h = (b - r) / d + 2
        break
      case b:
        h = (r - g) / d + 4
        break
    }
    h /= 6
  }

  // Convert to percentages
  h = Math.round(h * 360)
  s = Math.round(s * 100)
  l = Math.round(l * 100)

  // Apply adjustments if provided
  if (adjustments.lightness) {
    l = Math.max(0, Math.min(100, l + adjustments.lightness))
  }

  if (adjustments.saturation) {
    s = Math.max(0, Math.min(100, s + adjustments.saturation))
  }

  // return `hsl(${h}, ${s}%, ${l}%)`;
  return `${h}, ${s}%, ${l}%`
}

/**
 * Convert hexa color to rgb
 * @param hex hex color
 * @param opacity Optional - opacity
 * @returns
 */
export function hexToRgb(hex: string, opacity?: number) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)

  if (!result) return null

  if (opacity)
    return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}, ${opacity}`

  return `${parseInt(result[1], 16)}, ${parseInt(result[2], 16)}, ${parseInt(result[3], 16)}`
}

/**
 * Sleep
 * @param time in ms
 * @returns
 */
export function sleep(time: number = 500) {
  return new Promise((resolve) => setTimeout(resolve, time))
}
